var companyName = "Your Company Name";

function initializeProjectHeaderSettingsDialog() {
    document.getElementById("modal-project-header-settings-save-button").addEventListener("click", function() {
        saveProjectHeaderSettings();
    });
    setProjectHeaderSettingsDialogFields();
}

function openProjectHeaderSettingsDialog() {
    setProjectHeaderSettingsDialogFields();
    $('#modal-project-header-settings-dialog').modal('show');
}

function setProjectHeaderSettingsDialogFields() {
    document.getElementById("project-title-header-settings-text-input").value = activeProject.title;
    document.getElementById("company-name-header-settings-text-input").value = companyName;
}

function saveProjectHeaderSettings() {
    // get the beam project title
    var newProjectTitle = document.getElementById("project-title-header-settings-text-input").value;
    if(newProjectTitle !== activeProject.title) {
        document.getElementById("active-project-title").innerHTML = newProjectTitle;
        document.getElementById("project-title").innerHTML = newProjectTitle;
        activeProject.title = newProjectTitle;
        writeProjects([activeProject]);
    }
    
    // get the company name
    var newCompanyName = document.getElementById("company-name-header-settings-text-input").value;
    if(newCompanyName !== companyName) {
        document.getElementById("your-company-name").innerHTML = newCompanyName;
        companyName = newCompanyName;
        if(firebase.auth().currentUser === null || customerLevel !== "pro") {
            return;
        }
        var uid = firebase.auth().currentUser.uid;
        firebase.database().ref('users/' + uid).update({
            companyName: companyName
        });
    }
}
